export const ACTIVITY_VALIDATORS = {
  MIN_LENGTH: 2,
  MAX_LENGTH: 80
};

export const MAX_CONTEXT_LENGTH = 5000;
export const MAX_GUIDANCE_LENGTH = 20000;
